import { get, post, request } from '@/api/request';

const URI = "/moneyOrder"

// 对账管理-对账列表
export const listCheck = (page, size, params) => post(`${URI}/selectReconciliation?page=${page}&size=${size}`, params);
// 对账管理-保存修改对账
export const saveOrUpdateCheck = params => post(`${URI}/updateReconciliation`, params);
// 对账管理-获取对账信息
export const getCheck = id => get(`${URI}/info/${id}`);
// 对账管理-删除对账
export const delCheck = id => get(`${URI}/delete/${id}`);
// 对账管理-上传纸票
export const addCheck = params => post(`${URI}/saverMoneyOrderByhand`, params);
// 对账管理-导出
export const exportCheck = (params={}) => request({
    url: `${URI}/export`,
    method: 'post',
    responseType: 'blob',
    data: params
});
// 对账管理-删除对账
export const rollBack = id => get(`${URI}/rollback/${id}`);



// WEBPACK FOOTER //
// ./src/api/ticket/check.js